import type { PostingSummary } from "@/lib/api/catalogue";
import type { Application } from "@/lib/api/envoy";

/** What the skip dialog is asked about: the application, or the posting when there is none. */
export interface Skipping {
    application: Application | null;
    posting: Pick<PostingSummary, "posting_id" | "title" | "company"> | null;
}

/** Skip the application when there is one, else the posting by its id. */
export function skippingOf(
    application: Application | null | undefined,
    posting: Pick<PostingSummary, "posting_id" | "title" | "company">,
): Skipping {
    return application
        ? { application, posting: null }
        : {
              application: null,
              posting: {
                  posting_id: posting.posting_id,
                  title: posting.title,
                  company: posting.company,
              },
          };
}
